module.exports = __webpack_public_path__ + "static/img/icon_fire_bg@2x.40fcbe4e.png";